export default __webpack_public_path__ + "static/media/check-disabled.babe4907.svg";